module.exports = __webpack_public_path__ + "img/pdf-title-prestadores.304c77db.png";